/**
 * Cross-iframe contract for the confirmation dialog.
 *
 * The FrameDialog renders a body for a given {@link ConfirmType} and broadcasts a
 * {@link ConfirmResultPayload} over a {@link CONFIRM_BROADCAST_CHANNEL} once the user decides.
 *
 * The dialog is decision-only: it never executes the action. The opening frame (the table) owns
 * selection, the PATCH batch, and the refetch.
 */

/** Dedicated channel for confirm-dialog decisions. Same-origin VD iframes only. */
export const CONFIRM_BROADCAST_CHANNEL = 'vehicle-diagnostics-confirm-channel';

/**
 * Which confirmation body to render, and which action the opening frame should run on confirm.
 * Kept minimal (only the two bulk actions that exist today); promote to a registry if/when a
 * third consumer appears.
 */
export type ConfirmType = 'markSolved' | 'revertSolved';

export interface ConfirmResultPayload {
    kind: ConfirmType;
    /** Echoes the id the opener minted, so it can match this result to its own request. */
    correlationId: string;
    /** `true` on Confirm, `false` on Cancel/close — the opener reacts to both. */
    confirmed: boolean;
}
